// eslint-disable-next-line import/no-named-as-default
import api from './base.service';

export const getDailyScheduleReport = (date, atcu) => {
  return api().get(`/api/reports/shift?date=${date}&atcu=${atcu}`);
};

export const getMonthlyHoursReport = (dateFrom, dateTo, atcu) => {
  return api().get(`/api/reports/daily-assignment?dateFrom=${dateFrom}&dateTo=${dateTo}&atcu=${atcu}`);
};
